var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        "empty-text": _vm.emptyText,
        data: _vm.rows,
        "element-loading-text": _vm.$tableLoading,
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(255,255,255,0)",
        "header-cell-style": _vm.tableHeaderColor,
        "max-height": _vm.$tableMaxHeight,
        border: "",
      },
      on: { "selection-change": _vm.handleSelectionChange },
    },
    [
      _c("el-table-column", {
        attrs: { type: "selection", align: "center", width: "55" },
      }),
      _c("el-table-column", {
        attrs: {
          type: "index",
          fixed: "left",
          label: "STT",
          width: "55",
          align: "center",
        },
      }),
      _c("el-table-column", {
        attrs: {
          label: "Họ tên",
          "min-width": "220",
          fixed: "left",
          prop: "buyerName",
        },
      }),
      _c("el-table-column", {
        attrs: { label: "Ngày tạo", width: "190", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.formatDateTime(
                        scope.row.createdAt || scope.row.issuedAt
                      )
                    ) +
                    "\n      "
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Phương thức TT", width: "150", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(scope.row.paymentMethodName || "-") +
                    "\n      "
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Thanh toán", width: "130", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "span",
                  {
                    style: {
                      color: scope.row.paymentStatus ? "#1e88e5" : "#fb8c00",
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(scope.row.paymentStatus ? "Đã TT" : "Chưa TT") +
                        "\n        "
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: "Tổng tiền không chịu thuế",
          prop: "totalAmountWithoutTax",
          align: "right",
          width: "170",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.formatCurrency(scope.row.totalAmountWithoutTax)
                    ) +
                    "\n      "
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: "Tổng tiền chịu thuế",
          prop: "totalTaxAmount",
          align: "right",
          width: "170",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.formatCurrency(scope.row.totalTaxAmount)) +
                    "\n      "
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: "Tổng tiền",
          prop: "totalAmountWithTax",
          align: "right",
          width: "170",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.formatCurrency(scope.row.totalAmountWithTax)) +
                    "\n      "
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: "Mã số HĐ",
          prop: "invoiceNo",
          width: "200",
          align: "center",
        },
      }),
      _c("el-table-column", {
        attrs: { label: "Trạng thái", width: "170", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "span",
                  {
                    style: {
                      color: _vm.statusColor(
                        scope.row.invoiceStatus || scope.row.status
                      ),
                      fontWeight: 500,
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.statusLabel(
                            scope.row.invoiceStatus || scope.row.status
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Trạng thái gửi CQT", width: "170", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "span",
                  {
                    style: {
                      color: _vm.statusColorCQT(scope.row.exchangeStatus),
                      fontWeight: 500,
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.statusLabelCQT(scope.row.exchangeStatus)) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: "Mã CQT",
          prop: "codeOfTax",
          width: "170",
          align: "center",
        },
      }),
      _c("el-table-column", {
        attrs: {
          label: "Tác vụ",
          fixed: "right",
          align: "center",
          width: "110",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "el-tooltip",
                  { attrs: { content: "Tải về", placement: "top" } },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        circle: "",
                        icon: "el-icon-download",
                        loading: _vm.actionLoading[_vm.getRowKey(scope.row)],
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.downloadIssuedInvoice(scope.row)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }